<template>
    <div class="special-table">
        <div v-for="(rowArray, index) in tableArray" :key="index" class="row" >
            <span v-for="(item, key) in rowArray" :key="key" class="col"
                :class="{
                    'back':index===0,
                    'yellow': (parseInt(item,16)>0&&parseInt(item,16)<10) || parseInt(item,16)>=150,
                    'red': parseInt(item,16)>60&&parseInt(item,16)<150}">
                    <template v-if="transCodeToindexDescr(index,key)">
                        <el-tooltip class="item" effect="light" :content="transCodeToindexDescr(index,key)" placement="top-start">
                            <el-button class="item-btn">{{item === '0' ? '' : (item + '').toUpperCase()}}</el-button>
                        </el-tooltip>
                    </template>
                    <template v-else>
                        {{item === '0' ? '' : (item + '').toUpperCase()}}
                    </template>
            </span>
        </div>
    </div>
</template>
<script>
export default {
    name: "specialTable",
    props:{
        tableArray:{
            type:Array,
            default(){
                return []
            }
        },
        toolTipObj:{
            type:Object,
            default(){
                return {}
            }
        }
    },
    data(){
        return {
            // tableArray:[]
        }
    },
    mounted(){
        //this.tableArray = this.Generate2Darray()
        console.log(this.toolTipObj,"toolTipObj")
    },
    methods:{
        /**
         * @description: 生成二维数组渲染页面
         * @example
         * [
         *   [""  , 0 , 1 ,  2,  3,  4,  5,  6,  7,  8,  9,  10, 11, 12, 13, 14, 15, 16, 17, 18, 19, ],
         *   [""  , "", "", "", "", "", "", "",, "", "", "", "", "", "", "", "", "", "", "", "", "", ],
         *   [20  , "", "", "", "", "", "", "",, "", "", "", "", "", "", "", "", "", "", "", "", "", ],
         *   [40  , "", "", "", "", "", "", "",, "", "", "", "", "", "", "", "", "", "", "", "", "", ],
         *   ......
         *   [240 , "", "", "", "", "", "", "",, "", "", "", "", "", "", "", "", "", "", "", "", "", ]
         * ]
         * @returns 返回上面示例的二维数组
         * @param 无
         */
        Generate2Darray () {
            let resArr = [];
            for (let i = 0; i < 14; i++) {
                let rowArr = []
                for (let j = 0; j < 21; j++) {
                    let rowNum = i < 2 ? (j < 1 ? "" : (i < 1 ? (j - 1) : "")) : (j < 1 ? (i - 1) * 20 : "")
                    rowArr.push(rowNum)
                }
                resArr.push(rowArr)
            }
            return resArr;
        },
        /**
         * @param index 二维数组第一维度 下标
         * @param key 二维数组第二维度 下标
         */
        transCodeToindexDescr(index, key){
            let str;
            if (index > 0 && key > 1) {
                let code = (index - 1) * 20 + (key - 1);
                let descr = this.toolTipObj[code] ? this.toolTipObj[code].descr : false
                let devType = this.toolTipObj[code] ? this.toolTipObj[code].devType : false
                let codeNo = code
                // str = this.toolTipObj[code] ? `${descr} ? 注释: ${this.toolTipObj[code].descr}  : “” 设备类型: ${this.toolTipObj[code].devType}` : false
                str = codeNo + (descr ? (" " + descr) : "") + (devType ? (" " + devType) : "")
            }
            return str
        }
    }
}
</script>
<style lang="less" scoped>
.special-table{
    width: 100%;
    height: 100%;
    box-sizing: border-box;
    .row{
        height: 28px;
        line-height: 28px;
        box-sizing: border-box;
        .col{
            display: inline-block;
            width: 35px;
            height: 28px;
            float: left;
            text-align: center;
            box-sizing: border-box;
        }
        .yellow{
            color: #f4e000;
        }
        .red{
            color: red;
        }
        .back{
            border-bottom: 1px solid #000;
            color: #000;
            // background: #F4F4FA;
        }
        :first-child{
            border-right: 1px solid #000;
            color: #000;
            // background: #F4F4FA;
            .item-btn{
                // color: red;
                span{
                    color: #000;
                }
            }
        }
    }
}
</style>
<style lang="less">
.special-table{
    .row{
        .item-btn{
            border: none !important;
            padding:0;
            span{
                border: none !important;
            }
        }
        .yellow{
            color: #f4e000;
            .item-btn{
                color: #f4e000;
                span{
                    color: #f4e000;
                }
            }
        }
        .red{
            color: red;
            .item-btn{
                color: red;
                span{
                    color: red;
                }
            }
        }
    }
}
</style>
